import React, { useEffect, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import startCase from 'lodash/startCase';
import termsAndConditionsContent from '../../components/templates/termsTemplate';

const Terms = () => {
  const location = useLocation();

  const formatSlugToName = (slug) => {
    if (!slug || slug.toLowerCase() === 'default') return 'Default Company';
    let processed = slug.trim();
    const suffixes = ['LLC','Inc','Corp','Co','Ltd','LLP','PLC','GmbH','Pty','S.A.','S.L.'];
    let detected = '';
    for (let s of suffixes) {
      const re = new RegExp(`${s}$`, 'i');
      if (re.test(processed)) { detected = s; processed = processed.slice(0,-s.length); break; }
    }
    processed = processed.replace(/[_-]/g,' ');
    processed = processed.replace(/([a-zA-Z])([A-Z])(?!\d)/g,'$1 $2');
    processed = startCase(processed);
    processed = processed.replace(/([A-Za-z])\s+(\d)/g,'$1$2');
    return detected ? `${processed} ${detected}` : processed;
  };

  const getCompanyName = () => {
    const params = new URLSearchParams(location.search);
    const slug = params.get('appFlavor');
    return formatSlugToName(slug);
  };

  const companyName = getCompanyName();

  const sanitize = (name) => { const div = document.createElement('div'); div.textContent = name; return div.innerHTML; };
  const safeName = sanitize(companyName);

  const injectCompany = (html, name) => {
    const regex = /ReadRivals/gi;
    return html.replace(regex, name);
  };

  const processed = useMemo(()=> injectCompany(termsAndConditionsContent, safeName), [safeName]);

  useEffect(()=>{
    document.title = `${safeName} Terms & Conditions`;
    const meta = document.querySelector('meta[name="description"]');
    if (meta) meta.setAttribute('content', `${safeName} Terms & Conditions`); else {
      const m = document.createElement('meta');
      m.name='description';
      m.content = `${safeName} Terms & Conditions`;
      document.head.appendChild(m);
    }
  }, [safeName]);

  return (
    <div style={{ padding: '20px', maxWidth: '800px', margin: '0 auto' }}>
      {processed ? <div dangerouslySetInnerHTML={{ __html: processed }} /> : <p>Loading Terms & Conditions...</p>}
    </div>
  );
};

export default Terms;
